
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5ehzb", function(module, exports) {

$parcel$export(module.exports, "default", () => $528a3a050891c7cb$export$2e2bcd8739ae039);

var $aPdzS = parcelRequire("aPdzS");

var $eflS6 = parcelRequire("eflS6");

var $hCdov = parcelRequire("hCdov");

var $darcK = parcelRequire("darcK");

var $erVR3 = parcelRequire("erVR3");

var $2h5MD = parcelRequire("2h5MD");
class $528a3a050891c7cb$export$2e2bcd8739ae039 {
    static instance;
    rootEventBus = (0, $erVR3.rootEventBus);
    cCoord;
    circleRadius;
    pointRadiansBeforeAnim = [];
    pointInitialRadians = [];
    pointRadians = [];
    pointRefRadians = [];
    pointRedCoords = [];
    selectedRedPointTag = "";
    circlePoint;
    RedPointsArr = [];
    constructor(cCoord, CIRCLE_RADIUS, RADIANS){
        if (!$528a3a050891c7cb$export$2e2bcd8739ae039.instance) $528a3a050891c7cb$export$2e2bcd8739ae039.instance = this;
        const radians = RADIANS.map((r)=>(0, $darcK.normalizeRadian)(r));
        this.cCoord = cCoord;
        this.circleRadius = CIRCLE_RADIUS;
        this.pointRadiansBeforeAnim = [
            ...radians
        ];
        this.pointInitialRadians = [
            ...radians
        ];
        this.pointRefRadians = [
            ...radians
        ];
        this.pointRadians = radians;
        this.RedPointsArr = Array(radians.length).fill(null).map((_, vI)=>`p${vI + 1}`).map((pT)=>new (0, $eflS6.default)(pT, this.cCoord, (pT)=>this.setSelectedRedPointTag(pT), ()=>this.setSelectedRedPointTag("")));
        this.circlePoint = new (0, $aPdzS.default)(this.cCoord);
        this.pointRedCoords = (0, $hCdov.default)(this.cCoord, this.pointRadians, this.circleRadius);
        this.rootEventBus.on((0, $erVR3.EnumRootEventBus).setPointerMove, (coord)=>this.handleCursor(coord));
        this.rootEventBus.on((0, $erVR3.EnumRootEventBus).setPointerUp, ()=>this.setSelectedRedPointTag(""));
        this.rootEventBus.on((0, $erVR3.EnumRootEventBus).setRefRadians, ()=>this.setRefRadians());
        this.rootEventBus.on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.handleStartedCircleAnim());
        this.rootEventBus.on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.handleCompletedCircleAnim());
    }
    static getInstance = ()=>$528a3a050891c7cb$export$2e2bcd8739ae039.instance;
    getPointTag = (n)=>`p${n + 1}`;
    clearAll = ()=>[
            this.circlePoint,
            ...this.RedPointsArr
        ].forEach((p)=>p.clear());
    setAllVisible = (v)=>[
            this.circlePoint,
            ...this.RedPointsArr
        ].forEach((p)=>{
            p.visible = v;
            p.interactive = v;
        });
    getRadians = ()=>this.pointRadians;
    getInitialRadians = ()=>this.pointInitialRadians;
    getRefRadians = ()=>this.pointRefRadians;
    getRedPoints = ()=>this.RedPointsArr;
    getPoints = ()=>[
            this.circlePoint,
            ...this.RedPointsArr
        ];
    getPointsCoord = ()=>[
            this.cCoord,
            ...this.pointRedCoords
        ];
    getRedPointsCoord = ()=>this.pointRedCoords;
    addSetCoordExtraCode = (cb)=>this.addSetCoordExtraCode = cb;
    setSelectedRedPointTag(PointTag) {
        this.selectedRedPointTag = PointTag;
        const points = this.getRedPoints();
        points.forEach((p)=>p.eventMode = PointTag !== "" ? "none" : "static");
    }
    setRefRadians = ()=>this.pointRefRadians = [
            ...this.pointRadians
        ];
    handleStartedCircleAnim = ()=>{
        this.setAllVisible(false);
        this.pointRadiansBeforeAnim = [
            ...this.pointRadians
        ];
        this.pointRadians = [
            ...this.pointInitialRadians
        ];
        this.setCoord();
    };
    handleCompletedCircleAnim = ()=>{
        this.setAllVisible(true);
        this.pointRadians = [
            ...this.pointRadiansBeforeAnim
        ];
        const redPointArr = this.pointRadiansBeforeAnim.map((radian, rI)=>({
                pTag: this.getPointTag(rI),
                radian: radian
            }));
        this.setRadian(redPointArr, false);
    };
    setCoord() {
        this._setCoord();
    }
    setRadian(pointInfoArr, isSlider = false) {
        this._setRadian(pointInfoArr, isSlider);
    }
    draw() {
        const points = this.getPoints();
        [
            this.circlePoint,
            ...this.RedPointsArr
        ].forEach((p, pI)=>p.draw(points[pI]));
    }
    handleCursor(coord) {
        if (this.selectedRedPointTag == "") return;
        let radian = (0, $2h5MD.default)(this.cCoord, coord);
        this.setRadian([
            {
                pTag: this.selectedRedPointTag,
                radian: radian
            }
        ]);
    }
    _setRadian(pointInfoArr, isSlider = false) {
        const points = this.getRedPoints();
        points.forEach((p, pI)=>{
            pointInfoArr.forEach((pInfo)=>{
                if (p.tag == pInfo.pTag) {
                    const radian = (0, $darcK.normalizeRadian)(pInfo.radian);
                    this.pointRadians[pI] = radian;
                    if (isSlider == false) this.pointRefRadians[pI] = radian;
                    this.setCoord();
                }
            });
        });
    }
    _setCoord() {
        this.pointRedCoords = (0, $hCdov.default)(this.cCoord, this.pointRadians, this.circleRadius);
        this.RedPointsArr.forEach((point, pIndex)=>Object.assign(point, this.pointRedCoords[pIndex]));
        this.rootEventBus.emit((0, $erVR3.EnumRootEventBus).drawElements);
    }
}

});
parcelRegister("eflS6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c24f9d95553ff758$export$2e2bcd8739ae039);

var $16Wgx = parcelRequire("16Wgx");

var $aPdzS = parcelRequire("aPdzS");

var $16HUD = parcelRequire("16HUD");
class $c24f9d95553ff758$export$2e2bcd8739ae039 extends (0, $aPdzS.default) {
    tag;
    constructor(tag, coord, _handleDown, handleUpFunc){
        super(coord);
        this.tag = tag;
        this.fillColor = 0xFF0000;
        this.eventMode = "static";
        const handleDownFunc = ()=>_handleDown(this.tag);
        (0, $16Wgx.default)(this, {
            handleDownFunc: handleDownFunc,
            handleUpFunc: handleUpFunc
        }, (0, $16HUD.CustomCursorType).grab);
    }
}

});

parcelRegister("hCdov", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f1e3d11cd35fbad$export$2e2bcd8739ae039);

var $61Efw = parcelRequire("61Efw");
function $0f1e3d11cd35fbad$export$2e2bcd8739ae039(centerCoord, radians, radius) {
    return radians.map((angle)=>(0, $61Efw.default)(centerCoord, radius, angle));
}

});


parcelRegister("lO7zi", function(module, exports) {

$parcel$export(module.exports, "default", () => $32b82c432e792a1c$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");
class $32b82c432e792a1c$export$2e2bcd8739ae039 extends $iuB9z.Text {
    Layers = (0, $9ec1t.default).getInstance();
    constructor(name){
        super();
        this.text = name;
        this.style.fontSize = 35;
        this.anchor.set(.5);
        this.x = -50;
        this.y = -50;
        this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Info.addChild(this);
    updateCoord = (coord)=>Object.assign(this, coord);
}

});

parcelRegister("iiVV4", function(module, exports) {

$parcel$export(module.exports, "default", () => $77d1d03c022c980e$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $erVR3 = parcelRequire("erVR3");

var $3ANoO = parcelRequire("3ANoO");

var $hCdov = parcelRequire("hCdov");
class $77d1d03c022c980e$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    arcs = [];
    colors = [];
    strokeW = 5;
    radius = (0, $3ANoO.INITIAL_CIRCLE_RADIUS);
    radians = [];
    points = [];
    constructor(coord, radians, colors, strokeW = 5){
        super();
        Object.assign(this, coord);
        this.radians = radians;
        this.colors = colors;
        this.strokeW = strokeW;
        this.addGraphics(radians.length);
        this.addToLayer();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.clearAll());
    }
    addToLayer = ()=>this.Layers.Middle.addChild(this);
    setColors = (colors)=>this.colors = colors;
    setRadians = (radians)=>this.radians = radians;
    addGraphics(count) {
        this.arcs = Array(count).fill(new $iuB9z.Graphics());
        this.arcs.forEach((arc)=>this.addChild(arc));
    }
    clearAll = ()=>this.arcs.forEach((arc)=>arc.clear());
    draw(details, transparent = false) {
        Object.assign(this, details);
        const alpha = transparent ? 0 : 1;
        const points = (0, $hCdov.default)({
            x: 0,
            y: 0
        }, this.radians, this.radius);
        this.clearAll();
        this.radians.forEach((r, rI)=>{
            const ONE_DEGREE = Math.PI / 180;
            const lastelm = rI == this.radians.length - 1;
            const arc = this.arcs[rI];
            const point = points[rI];
            const endAngle = this.radians.length !== 1 ? this.radians[!lastelm ? rI + 1 : 0] : ONE_DEGREE * (r / ONE_DEGREE - 1);
            arc.moveTo(point.x, point.y).arc(0, 0, this.radius, r, endAngle).stroke({
                color: this.colors[rI],
                width: this.strokeW,
                alpha: !lastelm ? alpha : 1,
                cap: "round"
            });
        });
    }
}

});

parcelRegister("b2sIL", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d1b5ea3a6b050c9$export$2e2bcd8739ae039);

var $75RpY = parcelRequire("75RpY");

var $7d73p = parcelRequire("7d73p");

var $erVR3 = parcelRequire("erVR3");

var $7Nlkd = parcelRequire("7Nlkd");

var $iD90R = parcelRequire("iD90R");
class $5d1b5ea3a6b050c9$export$2e2bcd8739ae039 {
    Game = (0, $75RpY.default).getInstance();
    rootEventBus = (0, $erVR3.rootEventBus);
    EnumRootEventBus = (0, $erVR3.EnumRootEventBus);
    sliders = [];
    slidersProps = [];
    dim = this.Game.getDim();
    constructor(slidersProps, SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL){
        this.slidersProps = slidersProps;
        this.generateSliders(SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL);
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setAllVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setAllVisible(true));
    }
    getSliders = ()=>this.sliders;
    setAllVisible(v) {
        this.sliders.forEach((slider)=>slider.setSliderVisible(v));
        v && (0, $iD90R.showSlidersAnim)(this);
    }
    generateSliders(SLIDERS_COORD, SLIDERS_COORD_VERTICAL) {
        const coords = (0, $7Nlkd.getSliderCoords)(this.dim, SLIDERS_COORD, SLIDERS_COORD_VERTICAL);
        coords.forEach((coord, cI)=>{
            const sProps = this.slidersProps[cI];
            const slider = this.addSlider(coord, sProps, sProps.onUpdate);
            this.sliders.push(slider);
        });
    }
    addSlider(coord, sGProps, onUpdate) {
        const props = (0, $7Nlkd.generateSliderProps)(coord, sGProps.head, sGProps.colors, sGProps.subHead, sGProps.keepCurrSlider);
        return new (0, $7d73p.default)(props, onUpdate);
    }
}

});
parcelRegister("7d73p", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8928e96bfcf37d6$export$2e2bcd8739ae039);

var $erVR3 = parcelRequire("erVR3");

var $3bQOr = parcelRequire("3bQOr");

var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");
class $b8928e96bfcf37d6$export$2e2bcd8739ae039 {
    CustomSliderRenderer;
    options;
    handleOnUpdate;
    constructor(props, handleOnUpdate){
        this.options = {
            ...props
        };
        this.CustomSliderRenderer = new (0, $3bQOr.default)(this.options);
        this.handleOnUpdate = handleOnUpdate;
        this.addOnupdateSlider();
        this.addHandleEvent();
    }
    setScale = (x, y)=>this.CustomSliderRenderer.scale.set(x, y);
    setSliderVisible = (v)=>this.CustomSliderRenderer.visible = v;
    onHandleEnd = ()=>{
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).setRefRadians);
        if (!this.options.keepCurrSlider) this.CustomSliderRenderer.Slider.value = 100;
    };
    addHandleEvent() {
        const handleUpFunc = ()=>this.onHandleEnd();
        (0, $16Wgx.default)(this.CustomSliderRenderer.Slider, {
            handleUpFunc: handleUpFunc
        }, (0, $16HUD.CustomCursorType).pointer, undefined, true);
        this.CustomSliderRenderer.getBarGraphs().forEach((e)=>(0, $16Wgx.default)(e, {}, (0, $16HUD.CustomCursorType).default));
    }
    addOnupdateSlider() {
        this.CustomSliderRenderer.Slider.onUpdate.connect((value)=>this.handleOnUpdate(value));
    }
}

});
parcelRegister("3bQOr", function(module, exports) {

$parcel$export(module.exports, "default", () => $06a7e340cc14a36b$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $75RpY = parcelRequire("75RpY");

var $9ec1t = parcelRequire("9ec1t");

var $XcGus = parcelRequire("XcGus");
class $06a7e340cc14a36b$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Game = (0, $75RpY.default).getInstance();
    Layers = (0, $9ec1t.default).getInstance();
    isVertical = false;
    options;
    head = this.addChild(new $iuB9z.Text());
    subHead = this.addChild(new $iuB9z.Text());
    bg = this.addChild(new $iuB9z.Graphics());
    button = this.addChild(new $iuB9z.Graphics());
    barTransparent = this.addChild(new $iuB9z.Graphics());
    bar = this.addChild(new $iuB9z.Graphics());
    Slider;
    constructor(props){
        super();
        this.options = props;
        this.setCoord();
        this.getIsVertical();
        this.generateHead(props.head);
        props.subHead && this.generateSubHead(props.subHead);
        this.generateBg();
        this.generateSliderButton();
        this.generateBar(this.bar);
        this.generateBar(this.barTransparent, true);
        this.generateSlider();
        this.deactiveEventMode();
        this.addToLayer();
    }
    addToLayer = ()=>this.Layers.UI.addChild(this);
    setCoord = ()=>this.position.copyFrom(this.options);
    getBarGraphs = ()=>[
            this.bar,
            this.barTransparent
        ];
    deactiveEventMode = ()=>[
            this.bg,
            this.head,
            this.subHead
        ].forEach((e)=>e.eventMode = "none");
    getIsVertical() {
        const dim = this.Game.getDim();
        this.isVertical = dim.WIDTH < dim.HEIGHT;
    }
    generateHead(label) {
        this.head.text = label;
        this.head.style.fontWeight = "700";
        this.head.style.fontSize = this.isVertical ? 30 : 25;
        this.head.anchor.set(.5);
        this.head.x = this.isVertical ? 115 : 140;
        this.head.y = -90;
    }
    generateSubHead(label) {
        this.subHead.text = label;
        this.subHead.style.fontWeight = "500";
        this.subHead.style.fontSize = 15;
        this.subHead.anchor.set(.5);
        this.subHead.x = this.isVertical ? 115 : 140;
        this.subHead.y = -70;
    }
    generateBar(bar, isTransparent = false) {
        this.isVertical ? bar.roundRect(0, -10, 230, 20, 8) : this.bar.rect(0, -5, 280, 10);
        bar.fill({
            color: this.options.sliderStyle.barColor,
            alpha: isTransparent ? 0 : .5
        });
    }
    generateSliderButton() {
        this.isVertical ? this.button.circle(0, -10, 30) : this.button.rect(-15, -30, 30, 50);
        this.button.fill(this.options.sliderStyle.buttonColor);
        this.button.cursor = "none";
    }
    generateBg() {
        this.isVertical ? this.bg.roundRect(-25, -60, 280, 120, 30) : this.bg.roundRect(-25, -60, 330, 120, 25);
        this.bg.fill({
            color: this.options.sliderStyle.bgColor,
            alpha: .2
        }).stroke({
            color: 0x000000,
            width: 3
        });
    }
    generateSlider() {
        this.Slider = new (0, $XcGus.Slider)({
            bg: this.bar,
            fill: this.barTransparent,
            slider: this.button,
            min: 0,
            max: 200,
            value: 100
        });
        this.addChild(this.Slider);
    }
}

});
parcelRegister("XcGus", function(module, exports) {

$parcel$export(module.exports, "Slider", () => $3e950c0222bc5911$export$472062a354075cee);

var $ch1ud = parcelRequire("ch1ud");

var $4qR7W = parcelRequire("4qR7W");
var $3e950c0222bc5911$var$__defProp = Object.defineProperty;
var $3e950c0222bc5911$var$__defNormalProp = (obj, key, value)=>key in obj ? $3e950c0222bc5911$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3e950c0222bc5911$var$__publicField = (obj, key, value)=>$3e950c0222bc5911$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class $3e950c0222bc5911$export$472062a354075cee extends (0, $4qR7W.SliderBase) {
    constructor(options){
        super({
            slider1: options.slider,
            value1: options.value,
            ...options
        });
        $3e950c0222bc5911$var$__publicField(this, "sliderOptions");
        /** Fires when value is changing, on every move of slider. */ $3e950c0222bc5911$var$__publicField(this, "onUpdate", new (0, $ch1ud.Signal)());
        /** Fires when value changed, only when slider is released. */ $3e950c0222bc5911$var$__publicField(this, "onChange", new (0, $ch1ud.Signal)());
        this.sliderOptions = options;
        this.step = options.step || 1;
        this.value = options.value ?? this.min;
        this.updateSlider();
    }
    /** Return selected value. */ get value() {
        return this._value1;
    }
    /** Set selected value. */ set value(value) {
        if (value === this._value1) return;
        if (value < this.min) value = this.min;
        if (value > this.max) value = this.max;
        this._value1 = value;
        this.updateSlider();
        this.onUpdate?.emit(this.value);
    }
    set max(value) {
        super.max = value;
        this.updateSlider();
    }
    get max() {
        return super.max;
    }
    set min(value) {
        super.min = value;
        this.updateSlider();
    }
    get min() {
        return super.min;
    }
    set step(value) {
        super.step = value;
        this.updateSlider();
    }
    get step() {
        return super.step;
    }
    /** Set slider instance ot texture. */ // eslint-disable-next-line accessor-pairs
    set slider(value) {
        this.slider1 = value;
        this.updateSlider();
    }
    update(event) {
        super.update(event);
        if (!this.dragging) return;
        const obj = event.currentTarget;
        const { x: x } = obj.parent.worldTransform.applyInverse(event.global);
        const positionRatio = x / (this.bg?.width || 1);
        const rawValue = this.min + positionRatio * (this.max - this.min);
        this.value = Math.round(rawValue / this.step) * this.step;
    }
    change() {
        this.onChange?.emit(this.value);
    }
    updateSlider() {
        this.progress = ((this.value ?? this.min) - this.min) / (this.max - this.min) * 100;
        this._slider1.x = this.bg?.width / 100 * this.progress - this._slider1.width / 2;
        this._slider1.y = this.bg?.height / 2;
        if (this.sliderOptions?.showValue) {
            this.value1Text.text = `${Math.round(this.value)}`;
            const sliderPosX = this._slider1.x + this._slider1.width / 2;
            const sliderPosY = this._slider1.y;
            this.value1Text.x = sliderPosX + (this.sliderOptions.valueTextOffset?.x ?? 0);
            this.value1Text.y = sliderPosY + (this.sliderOptions.valueTextOffset?.y ?? 0);
        }
    }
    /**
   * Sets width of a Sliders background and fill.
   * If nineSliceSprite is set, then width will be set to nineSliceSprite.
   * If nineSliceSprite is not set, then width will control components width as Container.
   * @param value - Width value.
   */ set width(value) {
        super.width = value;
        this.updateSlider();
    }
    /** Gets width of a Slider. */ get width() {
        return super.width;
    }
    /**
   * Sets height of a Sliders background and fill.
   * If nineSliceSprite is set, then height will be set to nineSliceSprite.
   * If nineSliceSprite is not set, then height will control components height as Container.
   * @param value - Height value.
   */ set height(value) {
        super.height = value;
        this.updateSlider();
    }
    /** Gets height of a Slider. */ get height() {
        return super.height;
    }
    setSize(value, height) {
        super.setSize(value, height);
        this.updateSlider();
    }
}

});
parcelRegister("ch1ud", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignalConnections = module.exports.Signal = module.exports.CollectorWhile0 = module.exports.CollectorUntil0 = module.exports.CollectorLast = module.exports.CollectorArray = module.exports.Collector = void 0;

var $Zpq23 = parcelRequire("Zpq23");
Object.defineProperty(module.exports, "Collector", {
    enumerable: true,
    get: function() {
        return $Zpq23.Collector;
    }
});

var $1RTtl = parcelRequire("1RTtl");
Object.defineProperty(module.exports, "CollectorArray", {
    enumerable: true,
    get: function() {
        return $1RTtl.CollectorArray;
    }
});

var $fMnDk = parcelRequire("fMnDk");
Object.defineProperty(module.exports, "CollectorLast", {
    enumerable: true,
    get: function() {
        return $fMnDk.CollectorLast;
    }
});

var $7hwGg = parcelRequire("7hwGg");
Object.defineProperty(module.exports, "CollectorUntil0", {
    enumerable: true,
    get: function() {
        return $7hwGg.CollectorUntil0;
    }
});

var $5JvdW = parcelRequire("5JvdW");
Object.defineProperty(module.exports, "CollectorWhile0", {
    enumerable: true,
    get: function() {
        return $5JvdW.CollectorWhile0;
    }
});

var $iuPPu = parcelRequire("iuPPu");
Object.defineProperty(module.exports, "Signal", {
    enumerable: true,
    get: function() {
        return $iuPPu.Signal;
    }
});

var $5F25I = parcelRequire("5F25I");
Object.defineProperty(module.exports, "SignalConnections", {
    enumerable: true,
    get: function() {
        return $5F25I.SignalConnections;
    }
});

});
parcelRegister("Zpq23", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Collector = void 0;
/**
 * Base class for collectors.
 *
 * @typeparam THandler The function signature to be implemented by handlers.
 */ class $0b896a475a3b9c70$var$Collector {
    /**
     * Create a new collector.
     *
     * @param signal The signal to emit.
     */ constructor(signal){
        // eslint-disable-next-line dot-notation
        this.emit = (...args)=>{
            // eslint-disable-next-line dot-notation
            signal["emitCollecting"](this, args);
        };
    }
}
module.exports.Collector = $0b896a475a3b9c70$var$Collector;

});

parcelRegister("1RTtl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectorArray = void 0;

var $Zpq23 = parcelRequire("Zpq23");
/**
 * Returns the result of the all signal handlers from a signal emission in an array.
 *
 * @typeparam THandler The function signature to be implemented by handlers.
 */ class $15c5c55764104da5$var$CollectorArray extends $Zpq23.Collector {
    constructor(){
        super(...arguments);
        this.result = [];
    }
    handleResult(result) {
        this.result.push(result);
        return true;
    }
    /**
     * Get the list of results from the signal handlers.
     */ getResult() {
        return this.result;
    }
    /**
     * Reset the result
     */ reset() {
        this.result.length = 0;
    }
}
module.exports.CollectorArray = $15c5c55764104da5$var$CollectorArray;

});

parcelRegister("fMnDk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectorLast = void 0;

var $Zpq23 = parcelRequire("Zpq23");
/**
 * Returns the result of the last signal handler from a signal emission.
 *
 * @typeparam THandler The function signature to be implemented by handlers.
 */ class $b7cdabcc9cac1b40$var$CollectorLast extends $Zpq23.Collector {
    handleResult(result) {
        this.result = result;
        return true;
    }
    /**
     * Get the result of the last signal handler.
     */ getResult() {
        return this.result;
    }
    /**
     * Reset the result
     */ reset() {
        delete this.result;
    }
}
module.exports.CollectorLast = $b7cdabcc9cac1b40$var$CollectorLast;

});

parcelRegister("7hwGg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectorUntil0 = void 0;

var $Zpq23 = parcelRequire("Zpq23");
/**
 * Keep signal emissions going while all handlers return true.
 *
 * @typeparam THandler The function signature to be implemented by handlers.
 */ class $54d378a3aea7fe05$var$CollectorUntil0 extends $Zpq23.Collector {
    constructor(){
        super(...arguments);
        this.result = false;
    }
    handleResult(result) {
        this.result = result;
        return this.result;
    }
    /**
     * Get the result of the last signal handler.
     */ getResult() {
        return this.result;
    }
    /**
     * Reset the result
     */ reset() {
        this.result = false;
    }
}
module.exports.CollectorUntil0 = $54d378a3aea7fe05$var$CollectorUntil0;

});

parcelRegister("5JvdW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollectorWhile0 = void 0;

var $Zpq23 = parcelRequire("Zpq23");
/**
 * Keep signal emissions going while all handlers return false.
 *
 * @typeparam THandler The function signature to be implemented by handlers.
 */ class $42c9601c5911d643$var$CollectorWhile0 extends $Zpq23.Collector {
    constructor(){
        super(...arguments);
        this.result = false;
    }
    handleResult(result) {
        this.result = result;
        return !this.result;
    }
    /**
     * Get the result of the last signal handler.
     */ getResult() {
        return this.result;
    }
    /**
     * Reset the result
     */ reset() {
        this.result = false;
    }
}
module.exports.CollectorWhile0 = $42c9601c5911d643$var$CollectorWhile0;

});

parcelRegister("iuPPu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Signal = void 0;

var $gjie2 = parcelRequire("gjie2");

var $jYBaA = parcelRequire("jYBaA");
/**
 * A signal is a way to publish and subscribe to events.
 *
 * @typeparam THandler The function signature to be implemented by handlers.
 */ class $d7733b9d6c415f52$var$Signal {
    constructor(){
        this.head = new $jYBaA.SignalLink();
        this.hasNewLinks = false;
        this.emitDepth = 0;
        this.connectionsCount = 0;
    }
    /**
     * @returns The number of connections on this signal.
     */ getConnectionsCount() {
        return this.connectionsCount;
    }
    /**
     * @returns true if this signal has connections.
     */ hasConnections() {
        return this.connectionsCount > 0;
    }
    /**
     * Subscribe to this signal.
     *
     * @param callback This callback will be run when emit() is called.
     * @param order Handlers with a higher order value will be called later.
     */ connect(callback, order = 0) {
        this.connectionsCount++;
        const link = this.head.insert(callback, order);
        if (this.emitDepth > 0) {
            this.hasNewLinks = true;
            link.newLink = true;
        }
        return new $gjie2.SignalConnectionImpl(link, ()=>this.decrementConnectionCount());
    }
    decrementConnectionCount() {
        this.connectionsCount--;
    }
    /**
     * Unsubscribe from this signal with the original callback instance.
     * While you can use this method, the SignalConnection returned by connect() will not be updated!
     *
     * @param callback The callback you passed to connect().
     */ disconnect(callback) {
        for(let link = this.head.next; link !== this.head; link = link.next)if (link.callback === callback) {
            this.decrementConnectionCount();
            link.unlink();
            return true;
        }
        return false;
    }
    /**
     * Disconnect all handlers from this signal event.
     */ disconnectAll() {
        while(this.head.next !== this.head)this.head.next.unlink();
        this.connectionsCount = 0;
    }
    /**
     * Publish this signal event (call all handlers).
     */ emit(...args) {
        this.emitDepth++;
        for(let link = this.head.next; link !== this.head; link = link.next)if (link.isEnabled() && link.callback) link.callback.apply(null, args);
        this.emitDepth--;
        this.unsetNewLink();
    }
    emitCollecting(collector, args) {
        this.emitDepth++;
        for(let link = this.head.next; link !== this.head; link = link.next)if (link.isEnabled() && link.callback) {
            const result = link.callback.apply(null, args);
            if (!collector.handleResult(result)) break;
        }
        this.emitDepth--;
        this.unsetNewLink();
    }
    unsetNewLink() {
        if (this.hasNewLinks && this.emitDepth === 0) {
            for(let link = this.head.next; link !== this.head; link = link.next)link.newLink = false;
            this.hasNewLinks = false;
        }
    }
}
module.exports.Signal = $d7733b9d6c415f52$var$Signal;

});
parcelRegister("gjie2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignalConnectionImpl = void 0;
/**
 * Implementation of SignalConnection, for internal use only.
 * @private
 */ class $bdfc8edc156ba1ef$var$SignalConnectionImpl {
    /**
     * @param link The actual link of the connection.
     * @param parentCleanup Callback to cleanup the parent signal when a connection is disconnected
     */ constructor(link, parentCleanup){
        this.link = link;
        this.parentCleanup = parentCleanup;
    }
    disconnect() {
        if (this.link !== null) {
            this.link.unlink();
            this.link = null;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.parentCleanup();
            this.parentCleanup = null;
            return true;
        }
        return false;
    }
    set enabled(enable) {
        if (this.link) this.link.setEnabled(enable);
    }
    get enabled() {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        return this.link !== null && this.link.isEnabled();
    }
}
module.exports.SignalConnectionImpl = $bdfc8edc156ba1ef$var$SignalConnectionImpl;

});

parcelRegister("jYBaA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignalLink = void 0;
/**
 * SignalLink implements a doubly-linked ring with nodes containing the signal handlers.
 * @private
 */ class $e8b07411e29c3e31$var$SignalLink {
    constructor(prev = null, next = null, order = 0){
        this.enabled = true;
        this.newLink = false;
        this.callback = null;
        this.prev = prev !== null && prev !== void 0 ? prev : this;
        this.next = next !== null && next !== void 0 ? next : this;
        this.order = order;
    }
    isEnabled() {
        return this.enabled && !this.newLink;
    }
    setEnabled(flag) {
        this.enabled = flag;
    }
    unlink() {
        this.callback = null;
        this.next.prev = this.prev;
        this.prev.next = this.next;
    }
    insert(callback, order) {
        let after = this.prev;
        while(after !== this){
            if (after.order <= order) break;
            after = after.prev;
        }
        const link = new $e8b07411e29c3e31$var$SignalLink(after, after.next, order);
        link.callback = callback;
        after.next = link;
        link.next.prev = link;
        return link;
    }
}
module.exports.SignalLink = $e8b07411e29c3e31$var$SignalLink;

});


parcelRegister("5F25I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignalConnections = void 0;
/**
 * Represents a list of connections to a signal for easy disconnect.
 */ class $41f26753c16492bd$var$SignalConnections {
    constructor(){
        this.list = [];
    }
    /**
     * Add a connection to the list.
     * @param connection
     */ add(connection) {
        this.list.push(connection);
    }
    /**
     * Disconnect all connections in the list and empty the list.
     */ disconnectAll() {
        for (const connection of this.list)connection.disconnect();
        this.list = [];
    }
    /**
     * @returns The number of connections in this list.
     */ getCount() {
        return this.list.length;
    }
    /**
     * @returns true if this list is empty.
     */ isEmpty() {
        return this.list.length === 0;
    }
}
module.exports.SignalConnections = $41f26753c16492bd$var$SignalConnections;

});


parcelRegister("4qR7W", function(module, exports) {

$parcel$export(module.exports, "SliderBase", () => $95c26a148d10f103$export$9418495bb635ebde);

var $iuB9z = parcelRequire("iuB9z");

var $e9tFQ = parcelRequire("e9tFQ");

var $9AONF = parcelRequire("9AONF");
var $95c26a148d10f103$var$__defProp = Object.defineProperty;
var $95c26a148d10f103$var$__defNormalProp = (obj, key, value)=>key in obj ? $95c26a148d10f103$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $95c26a148d10f103$var$__publicField = (obj, key, value)=>$95c26a148d10f103$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class $95c26a148d10f103$export$9418495bb635ebde extends (0, $e9tFQ.ProgressBar) {
    constructor(options){
        super(options);
        $95c26a148d10f103$var$__publicField(this, "_slider1");
        $95c26a148d10f103$var$__publicField(this, "_slider2");
        $95c26a148d10f103$var$__publicField(this, "value1Text");
        $95c26a148d10f103$var$__publicField(this, "value2Text");
        $95c26a148d10f103$var$__publicField(this, "_value1");
        $95c26a148d10f103$var$__publicField(this, "_value2");
        $95c26a148d10f103$var$__publicField(this, "dragging", 0);
        /** Minimal value. */ $95c26a148d10f103$var$__publicField(this, "_min", 0);
        /** Maximal value. */ $95c26a148d10f103$var$__publicField(this, "_max", 100);
        /** Progress value step */ $95c26a148d10f103$var$__publicField(this, "_step", 1);
        $95c26a148d10f103$var$__publicField(this, "startX");
        $95c26a148d10f103$var$__publicField(this, "startUpdateValue1");
        $95c26a148d10f103$var$__publicField(this, "startUpdateValue2");
        $95c26a148d10f103$var$__publicField(this, "settings");
        this.settings = options;
        this.slider1 = options.slider1;
        this.slider2 = options.slider2;
        this.min = options.min ?? 0;
        this.max = options.max ?? 100;
    }
    init(progressBarOptions) {
        super.init(progressBarOptions);
        if (this.fill) this.fill.eventMode = "none";
    }
    /**
   * Sets Slider1 instance.
   * @param value - Container or string with texture name.
   */ set slider1(value) {
        if (!value) return;
        if (this._slider1) {
            this.slider1.removeAllListeners();
            this.slider1.destroy();
        }
        this._slider1 = this.createSlider(value);
        if (this.settings.showValue && !this.value1Text) {
            const TextClass = this.settings.valueTextClass ?? (0, $iuB9z.Text);
            this.value1Text = new TextClass({
                text: "",
                style: this.settings.valueTextStyle || {
                    fill: 16777215
                }
            });
            this.value1Text.anchor.set(0.5);
            this.addChild(this.value1Text);
        }
    }
    /** Get Slider1 instance. */ get slider1() {
        return this._slider1;
    }
    /**
   * Sets Slider2 instance.
   * @param value - Container or string with texture name.
   */ set slider2(value) {
        if (!value) return;
        if (this._slider2) {
            this.slider2.removeAllListeners();
            this.slider2.destroy();
        }
        this._slider2 = this.createSlider(value);
        if (this.settings.showValue && !this.value2Text) {
            const TextClass = this.settings.valueTextClass ?? (0, $iuB9z.Text);
            this.value2Text = new TextClass({
                text: "",
                style: this.settings.valueTextStyle || {
                    fill: 16777215
                }
            });
            this.value2Text.anchor.set(0.5);
            this.addChild(this.value2Text);
        }
    }
    /** Get Slider2 instance. */ get slider2() {
        return this._slider2;
    }
    /**
   * Set bg.
   * @param bg
   */ setBackground(bg) {
        if (this.bg) this.bg.removeAllListeners();
        super.setBackground(bg);
        this.activateBG();
    }
    activateBG() {
        this.bg.eventMode = "static";
        this.bg.on("pointerdown", this.startUpdate, this).on("globalpointermove", this.update, this).on("pointerup", this.endUpdate, this).on("pointerupoutside", this.endUpdate, this);
    }
    createSlider(sliderData) {
        const slider = (0, $9AONF.getView)(sliderData);
        const onPointerDown = (event)=>{
            if (this.bg) event.currentTarget = this.bg;
            this.startUpdate(event);
        };
        slider.eventMode = "static";
        slider.on("pointerdown", onPointerDown).on("pointerup", this.endUpdate, this).on("pointerupoutside", this.endUpdate, this);
        slider.x = slider.width / 2;
        const container = new (0, $iuB9z.Container)();
        container.addChild(slider);
        if (slider instanceof (0, $iuB9z.Sprite)) slider.anchor.set(0.5);
        container.y = this.bg?.height ? this.bg?.height / 2 : 0;
        this.addChild(container);
        return container;
    }
    startUpdate(event) {
        this.dragging = 1;
        const obj = event.currentTarget;
        this.startX = obj.parent.worldTransform.applyInverse(event.global).x;
        this.startUpdateValue1 = this._value1;
        this.startUpdateValue2 = this._value2;
        this.update(event);
    }
    endUpdate() {
        if (!this.dragging) return;
        this.dragging = 0;
        if (!!this.startX || this.startUpdateValue1 !== this._value1 || this.startUpdateValue2 !== this._value2) this.change();
        this.startUpdateValue1 = null;
        this.startUpdateValue2 = null;
    }
    onClick() {
        this.change();
    }
    /* Called when dragging started and on every move. */ update(_event) {
        const obj = _event.currentTarget;
        const { x: x } = obj.parent.worldTransform.applyInverse(_event.global);
        if (x !== this.startX) this.startX = null;
    }
    /** Called when dragging stopped. */ change() {}
    /**
   * Set max value.
   * @param value
   */ set max(value) {
        this._max = value;
    }
    /** Get max value. */ get max() {
        return this._max;
    }
    /**
   * Set min value.
   * @param value
   */ set min(value) {
        this._min = value;
    }
    /** Get min value. */ get min() {
        return this._min;
    }
    /**
   * Set step value.
   * @param value
   */ set step(value) {
        this._step = value;
    }
    /** Get step value. */ get step() {
        return this._step;
    }
}

});
parcelRegister("e9tFQ", function(module, exports) {

$parcel$export(module.exports, "ProgressBar", () => $64dbf4c474740b9a$export$c17561cb55d4db30);

var $iuB9z = parcelRequire("iuB9z");

var $9AONF = parcelRequire("9AONF");
var $64dbf4c474740b9a$var$__defProp = Object.defineProperty;
var $64dbf4c474740b9a$var$__defNormalProp = (obj, key, value)=>key in obj ? $64dbf4c474740b9a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $64dbf4c474740b9a$var$__publicField = (obj, key, value)=>$64dbf4c474740b9a$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class $64dbf4c474740b9a$export$c17561cb55d4db30 extends (0, $iuB9z.Container) {
    /**
   * Creates a ProgressBar.
   * @param options - Options.
   * @param { Sprite | Graphics | Texture | string } options.bg - Background of the ProgressBar.
   * <br> If you pass a string, it will be used as a texture name.
   * <br> If you want to use NineSliceSprite, you have to pass a text
   * (name of texture) or an instance of Texture as a parameter here.
   * @param { Sprite | Graphics | Texture | string } options.fill - Fill of the ProgressBar.
   * <br> If you pass a string, it will be used as a texture name.
   * <br> If you want to use NineSliceSprite, you have to pass a text
   * (name of texture) or an instance of Texture as a parameter here.
   * @param { FillPaddings } options.fillPaddings - Fill offsets.
   * @param { number } options.fillPaddings.top - Fill top offset.
   * @param { number } options.fillPaddings.right - Fill right offset.
   * @param { number } options.fillPaddings.bottom - Fill bottom offset.
   * @param { number } options.fillPaddings.left - Fill left offset.
   * @param { NineSliceSprite } options.nineSliceSprite - NineSliceSprite values for bg and fill.
   * @param { Array } options.nineSliceSprite.bg - NineSliceSprite config for bg ([number, number, number, number]).
   * <br> <b>!!! IMPORTANT:</b> To make it work, you have to pass a bg parameter as texture name or texture instance.
   * @param { Array } options.nineSliceSprite.fill - NineSliceSprite config fill ([number, number, number, number]).
   * <br> <b>!!! IMPORTANT:</b> To make it work, you have to pass a fill parameter as texture name or texture instance.
   * @param { number } options.progress - Initial progress value.
   */ constructor(options){
        super();
        $64dbf4c474740b9a$var$__publicField(this, "bg");
        $64dbf4c474740b9a$var$__publicField(this, "fill");
        $64dbf4c474740b9a$var$__publicField(this, "fillMask");
        $64dbf4c474740b9a$var$__publicField(this, "progressStart", 0);
        $64dbf4c474740b9a$var$__publicField(this, "_progress", 0);
        $64dbf4c474740b9a$var$__publicField(this, "options");
        /** Container, that holds all inner views. */ $64dbf4c474740b9a$var$__publicField(this, "innerView");
        /** Container, given as a constructor parameter that is a button view. */ $64dbf4c474740b9a$var$__publicField(this, "_view");
        this.options = options;
        this.innerView = new (0, $iuB9z.Container)();
        this.addChild(this.innerView);
        if (options?.bg && options?.fill) this.init(options);
    }
    /**
   * Initialize ProgressBar.
   * @param root0
   * @param root0.bg - Background texture.
   * @param root0.fill - Fill texture.
   * @param root0.fillPaddings - Fill offset.
   * @param root0.progress - Initial progress value.
   */ init({ bg: bg, fill: fill, fillPaddings: fillPaddings, progress: progress }) {
        this.setBackground(bg);
        this.setFill(fill, fillPaddings);
        this.progress = progress;
    }
    /**
   * Set bg.
   * @param bg
   */ setBackground(bg) {
        if (this.bg) this.bg.destroy();
        if (this.options?.nineSliceSprite) {
            if (typeof bg === "string") this.bg = new (0, $iuB9z.NineSliceSprite)({
                texture: (0, $iuB9z.Texture).from(bg),
                leftWidth: this.options.nineSliceSprite.bg[0],
                topHeight: this.options.nineSliceSprite.bg[1],
                rightWidth: this.options.nineSliceSprite.bg[2],
                bottomHeight: this.options.nineSliceSprite.bg[3]
            });
            else if (bg instanceof (0, $iuB9z.Texture)) this.bg = new (0, $iuB9z.NineSliceSprite)({
                texture: bg,
                leftWidth: this.options.nineSliceSprite.bg[0],
                topHeight: this.options.nineSliceSprite.bg[1],
                rightWidth: this.options.nineSliceSprite.bg[2],
                bottomHeight: this.options.nineSliceSprite.bg[3]
            });
            else console.warn(`NineSliceSprite can not be used with views set as Container.
                    Pass the texture or texture name as instead of the Container extended instance.`);
        }
        if (!this.bg) this.bg = (0, $9AONF.getView)(bg);
        this.innerView.addChildAt(this.bg, 0);
    }
    /**
   * Set fill.
   * @param fill
   * @param fillPadding
   */ setFill(fill, fillPadding) {
        if (this.fill) this.fill.destroy();
        if (this.bg instanceof (0, $iuB9z.Sprite) && fill === this.bg) {
            console.warn("Can not use same Sprite instance for bg and fill.");
            return;
        }
        if (this.options?.nineSliceSprite) {
            if (typeof fill === "string" || fill instanceof (0, $iuB9z.Texture)) this.fill = new (0, $iuB9z.NineSliceSprite)({
                texture: typeof fill === "string" ? (0, $iuB9z.Texture).from(fill) : fill,
                leftWidth: this.options.nineSliceSprite.fill[0],
                topHeight: this.options.nineSliceSprite.fill[1],
                rightWidth: this.options.nineSliceSprite.fill[2],
                bottomHeight: this.options.nineSliceSprite.fill[3]
            });
            else {
                console.warn(`NineSliceSprite can not be used with views set as Container.
                    Pass the texture or texture name as instead of the Container extended instance.`);
                this.fill = (0, $9AONF.getView)(fill);
            }
        } else this.fill = (0, $9AONF.getView)(fill);
        this.innerView.addChildAt(this.fill, 1);
        const offsetX = fillPadding?.left ?? 0;
        const offsetY = fillPadding?.top ?? 0;
        this.fill.x = offsetX;
        this.fill.y = offsetY;
        if (this.fillMask) {
            this.fill.mask = null;
            this.fillMask.destroy();
        }
        const leftWidth = this.fill.width / 2;
        const rightWidth = this.fill.width / 2;
        const topHeight = this.fill.height / 2;
        const bottomHeight = this.fill.height / 2;
        let texture = (0, $iuB9z.Texture).WHITE;
        if (this.fill instanceof (0, $iuB9z.Sprite) && this.fill.texture) texture = this.fill.texture;
        this.fillMask = new (0, $iuB9z.NineSliceSprite)({
            texture: texture,
            leftWidth: leftWidth,
            topHeight: topHeight,
            rightWidth: rightWidth,
            bottomHeight: bottomHeight
        });
        this.fillMask.position.copyFrom(this.fill);
        this.addChild(this.fillMask);
        this.fill.mask = this.fillMask;
    }
    validate(progress) {
        progress = Math.round(progress);
        if (progress < 0) return 0;
        if (progress > 100) return 100;
        return progress;
    }
    /** Set current progress percentage value. */ set progress(progress) {
        this._progress = this.validate(progress);
        if (!this.fill) return;
        if (this.fillMask) {
            this.fill.mask = null;
            this.fillMask.width = this.fill.width / 100 * (this._progress - this.progressStart);
            this.fillMask.x = this.progressStart / 100 * this.fill.width + this.fill.x;
            this.fillMask.height = this.fill.height;
            this.fill.mask = this.fillMask;
        }
    }
    /** Return current progress percentage value. */ get progress() {
        return this._progress;
    }
    /**
   * Sets width of a ProgressBars background and fill.
   * If nineSliceSprite is set, then width will be set to nineSliceSprite.
   * If nineSliceSprite is not set, then width will control components width as Container.
   * @param width - Width value.
   */ set width(width) {
        if (this.options?.nineSliceSprite) {
            if (this.bg) this.bg.width = width;
            if (this.fill) {
                const leftPadding = this.options.fillPaddings?.left ?? 0;
                const rightPadding = this.options.fillPaddings?.right ?? 0;
                this.fill.width = width - leftPadding - rightPadding;
                this.fillMask.width = width - leftPadding - rightPadding;
            }
            this.progress = this._progress;
        } else super.width = width;
    }
    /** Gets width of a ProgressBar. */ get width() {
        return super.width;
    }
    /**
   * Sets height of a ProgressBars background and fill.
   * If nineSliceSprite is set, then height will be set to nineSliceSprite.
   * If nineSliceSprite is not set, then height will control components height as Container.
   * @param height - Height value.
   */ set height(height) {
        if (this.options?.nineSliceSprite) {
            if (this.bg) this.bg.height = height;
            if (this.fill) {
                const topPadding = this.options.fillPaddings?.top ?? 0;
                const bottomPadding = this.options.fillPaddings?.bottom ?? 0;
                this.fill.height = height - topPadding - bottomPadding;
                this.fillMask.height = height - topPadding - bottomPadding;
            }
            this.progress = this._progress;
        } else super.height = height;
    }
    /** Gets height of a ProgressBar. */ get height() {
        return super.height;
    }
    setSize(value, height) {
        if (this.options?.nineSliceSprite) {
            if (this.bg) this.bg.setSize(value, height);
            if (this.fill) {
                if (typeof value === "object") {
                    height = value.height ?? value.width;
                    value = value.width;
                } else height = height ?? value;
                const topPadding = this.options.fillPaddings?.top ?? 0;
                const bottomPadding = this.options.fillPaddings?.bottom ?? 0;
                const leftPadding = this.options.fillPaddings?.left ?? 0;
                const rightPadding = this.options.fillPaddings?.right ?? 0;
                this.fill.setSize(value - leftPadding - rightPadding, height - topPadding - bottomPadding);
                this.fillMask.setSize(value - leftPadding - rightPadding, height - topPadding - bottomPadding);
            }
            this.progress = this._progress;
        } else super.setSize(value, height);
    }
}

});
parcelRegister("9AONF", function(module, exports) {

$parcel$export(module.exports, "getView", () => $eada55855a105cab$export$513f42987b822fd7);

var $iuB9z = parcelRequire("iuB9z");
function $eada55855a105cab$export$513f42987b822fd7(view) {
    if (typeof view === "string") return (0, $iuB9z.Sprite).from(view);
    if (view instanceof (0, $iuB9z.Texture)) return new (0, $iuB9z.Sprite)(view);
    return view;
}

});






parcelRegister("7Nlkd", function(module, exports) {

$parcel$export(module.exports, "getSliderCoords", () => $1a6e9a2b4836cba1$export$683fd302086be208);
$parcel$export(module.exports, "generateSliderProps", () => $1a6e9a2b4836cba1$export$802e1960ddee5612);
function $1a6e9a2b4836cba1$export$683fd302086be208(dim, SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL) {
    return dim.WIDTH > dim.HEIGHT ? SLIDERS_COORD : SLIDERS_COORD_OFFSET_VERTICAL.map((o)=>({
            x: dim.WIDTH / 2 + o.x,
            y: dim.HEIGHT / 2 + o.y
        }));
}
function $1a6e9a2b4836cba1$export$802e1960ddee5612(coord, head, colors, subHead = "", keepCurrSlider = false) {
    return {
        x: coord.x,
        y: coord.y,
        head: head,
        subHead: subHead,
        keepCurrSlider: keepCurrSlider,
        sliderStyle: colors
    };
}

});


parcelRegister("e8wW1", function(module, exports) {

$parcel$export(module.exports, "default", () => $58cf65e0167523aa$export$2e2bcd8739ae039);

var $75RpY = parcelRequire("75RpY");

var $erVR3 = parcelRequire("erVR3");

var $iLQpn = parcelRequire("iLQpn");

var $1XBiE = parcelRequire("1XBiE");
class $58cf65e0167523aa$export$2e2bcd8739ae039 {
    infoSliderCoord;
    runAnimations;
    getDelayForStartAnim;
    Game;
    PlayAnimationButton;
    CancelAnimationButton;
    constructor(infoSliderCoord, runAnimations, getDelayForStartAnim = ()=>0){
        this.infoSliderCoord = infoSliderCoord;
        this.runAnimations = runAnimations;
        this.getDelayForStartAnim = getDelayForStartAnim;
        this.Game = (0, $75RpY.default).getInstance();
        this.addPlayAnimButton();
        this.addCancelAnimButton();
    }
    getAnimButtonCoord() {
        const dims = this.Game.getDim();
        if (dims.HEIGHT > dims.WIDTH) return {
            x: dims.WIDTH / 2,
            y: dims.HEIGHT / 2 - 380
        };
        else return {
            x: this.infoSliderCoord.x,
            y: this.infoSliderCoord.y + 230
        };
    }
    getScale() {
        const dims = this.Game.getDim();
        return dims.HEIGHT > dims.WIDTH ? 1.35 : 1;
    }
    addPlayAnimButton() {
        const handleFunc = ()=>{
            const startAnim = ()=>{
                (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).startedCircleAnim);
                this.runAnimations();
                this.PlayAnimationButton.visible = false;
            };
            setTimeout(()=>startAnim(), this.getDelayForStartAnim());
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).closeSwitcher);
        };
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.PlayAnimationButton.visible = true);
        this.PlayAnimationButton = new (0, $iLQpn.default)(handleFunc);
        Object.assign(this.PlayAnimationButton, this.getAnimButtonCoord());
        this.PlayAnimationButton.scale.set(this.getScale());
    }
    addCancelAnimButton() {
        const handleFunc = ()=>{
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).cancelledCircleAnim);
            this.CancelAnimationButton.visible = false;
        };
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.CancelAnimationButton.visible = true);
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.CancelAnimationButton.visible = false);
        this.CancelAnimationButton = new (0, $1XBiE.default)(handleFunc);
        this.CancelAnimationButton.visible = false;
        Object.assign(this.CancelAnimationButton, this.getAnimButtonCoord());
        this.CancelAnimationButton.scale.set(this.getScale());
    }
}

});
parcelRegister("iLQpn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6317a0356d5fc3d$export$2e2bcd8739ae039);

var $llFKB = parcelRequire("llFKB");
const $d6317a0356d5fc3d$var$buttonStyle = {
    width: 200,
    height: 40,
    defaultColor: 0x21D4FE,
    hoverColor: 0x10C3F0,
    pressedColor: 0x21D4FE,
    borderColor: 0x10C3F0,
    titleColor: 0x0195b8,
    titleFontSize: 20,
    wordWrapWidth: 200,
    borderRadius: 10
};
class $d6317a0356d5fc3d$export$2e2bcd8739ae039 extends (0, $llFKB.default) {
    constructor(handleFunc){
        super("Play Animation", $d6317a0356d5fc3d$var$buttonStyle, handleFunc);
    }
}

});
parcelRegister("llFKB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9544c38f45ee9275$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");
class $9544c38f45ee9275$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    bg;
    title;
    style;
    titleText;
    handleFunc;
    constructor(title, style, handleFunc){
        super();
        this.style = style;
        this.titleText = title;
        this.handleFunc = handleFunc;
        this.addBg(style);
        this.addTitle(title, style.titleColor);
        this.handleEvents();
        this.addToLayer();
    }
    addToLayer = ()=>this.Layers.UI.addChild(this);
    handleEvents() {
        const handleDownFunc = ()=>{
            this.drawBg(this.style, this.style.pressedColor);
            this.handleFunc();
        };
        const handleUpFunc = ()=>this.drawBg(this.style, this.style.hoverColor);
        (0, $16Wgx.default)(this, {
            handleDownFunc: handleDownFunc,
            handleUpFunc: handleUpFunc
        }, (0, $16HUD.CustomCursorType).pointer, undefined, true);
        this.on("pointerleave", ()=>this.drawBg(this.style, this.style.defaultColor));
    }
    addTitle(title, color) {
        this.title = this.addChild(new $iuB9z.Text({
            text: title
        }));
        this.title.style = {
            fill: color,
            fontSize: this.style.titleFontSize,
            wordWrap: true,
            wordWrapWidth: this.style.wordWrapWidth,
            align: "center"
        };
        this.title.anchor.set(.5);
    }
    addBg(style) {
        this.bg = this.addChild(new $iuB9z.Graphics());
        this.drawBg(style, style.defaultColor);
    }
    drawBg(style, color) {
        this.bg.clear().roundRect(-style.width / 2, -style.height / 2, style.width, style.height, style.borderRadius).stroke({
            width: 5,
            color: style.borderColor
        }).fill(color);
    }
    handleTitle(title, color) {
        this.titleText = title;
        this.title.text = title;
        this.title.style.fill = color;
    }
}

});


parcelRegister("1XBiE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e22200a79bfe5c0$export$2e2bcd8739ae039);

var $llFKB = parcelRequire("llFKB");
const $6e22200a79bfe5c0$var$buttonStyle = {
    width: 200,
    height: 40,
    defaultColor: 0xE13341,
    hoverColor: 0xCF2E3B,
    pressedColor: 0xE13341,
    borderColor: 0xCF2E3B,
    titleColor: 0xEDEDED,
    titleFontSize: 20,
    wordWrapWidth: 200,
    borderRadius: 10
};
class $6e22200a79bfe5c0$export$2e2bcd8739ae039 extends (0, $llFKB.default) {
    constructor(handleFunc){
        super("Cancel Animation", $6e22200a79bfe5c0$var$buttonStyle, handleFunc);
    }
}

});


parcelRegister("fGH3X", function(module, exports) {

$parcel$export(module.exports, "default", () => $a630205ec3c40818$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $75RpY = parcelRequire("75RpY");

var $9ec1t = parcelRequire("9ec1t");

var $7vBln = parcelRequire("7vBln");

var $cyNtl = parcelRequire("cyNtl");

var $2Z2Y1 = parcelRequire("2Z2Y1");

var $6cuzD = parcelRequire("6cuzD");

var $3ANoO = parcelRequire("3ANoO");
class $a630205ec3c40818$export$2e2bcd8739ae039 extends $iuB9z.Container {
    static instance;
    Game = (0, $75RpY.default).getInstance();
    Layers = (0, $9ec1t.default).getInstance();
    infoSliderDims = (0, $3ANoO.INFO_SLIDER_DIMS);
    infoSliderAssets;
    InfoSliderDots = [];
    constructor(coord){
        super();
        if (!$a630205ec3c40818$export$2e2bcd8739ae039.instance) $a630205ec3c40818$export$2e2bcd8739ae039.instance = this;
        Object.assign(this, coord);
        this.infoSliderAssets = (0, $7vBln.default).getInfoSliderAssetURLs();
        this.isPortial();
        new (0, $2Z2Y1.default)(this.infoSliderDims);
        new (0, $cyNtl.default)(this.infoSliderAssets, this.infoSliderDims);
        this.addDots();
        this.addToLayer();
    }
    static getInstance = ()=>$a630205ec3c40818$export$2e2bcd8739ae039.instance;
    addToLayer = ()=>this.Layers.UI.addChild(this);
    isPortial() {
        const dim = this.Game.getDim();
        if (dim.WIDTH > dim.HEIGHT) return;
        this.x = dim.WIDTH / 2;
        this.y = this.infoSliderDims.height / 2 + 50;
        this.scale.set(1.3);
    }
    addDots() {
        const lenghtISA = this.infoSliderAssets.length;
        this.infoSliderAssets.forEach((a, aI)=>{
            const even = lenghtISA % 2 == 1 ? true : false;
            const x = (aI - lenghtISA / 2 + (even ? .5 : .5)) * 30;
            const dot = new (0, $6cuzD.default)(aI, x, this.infoSliderDims);
            this.InfoSliderDots.push(dot);
        });
    }
}

});
parcelRegister("cyNtl", function(module, exports) {

$parcel$export(module.exports, "default", () => $17167019e781eef9$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $fGH3X = parcelRequire("fGH3X");

var $lnWcW = parcelRequire("lnWcW");

var $WbeEW = parcelRequire("WbeEW");

var $7vBln = parcelRequire("7vBln");

var $erVR3 = parcelRequire("erVR3");
const $17167019e781eef9$var$MASK_PATH = "/info-slider/mask.png";
class $17167019e781eef9$export$2e2bcd8739ae039 extends $iuB9z.Container {
    InfoSlider = (0, $fGH3X.default).getInstance();
    Pages;
    currPageIndex = 0;
    infoSliderDims;
    infoSliderAssets;
    constructor(infoSliderAssets, infoSliderDims){
        super();
        this.infoSliderAssets = infoSliderAssets;
        this.infoSliderDims = infoSliderDims;
        this.addPages();
        this.addMask();
        this.addFrame();
        this.addToCon();
        this.calcBoundaryStatus();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).setInfoSliderPage, (pNumber)=>this.setPage(pNumber));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).setInfoSliderPageWArr, (v)=>this.setPageWithArrow(v));
    }
    addToCon = ()=>this.InfoSlider.addChild(this);
    calcBoundaryStatus() {
        const state = this.currPageIndex == 0 ? "first" : this.currPageIndex == this.infoSliderAssets.length - 1 ? "last" : "middle";
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).updateEdgeState, state);
    }
    addFrame() {
        const width = this.infoSliderDims.width;
        const height = this.infoSliderDims.height;
        const frame = new $iuB9z.Graphics().roundRect(-this.infoSliderDims.width / 2, -this.infoSliderDims.height / 2, width, height, 10).stroke({
            color: 0x000000,
            width: 3
        });
        this.addChild(frame);
    }
    addMask() {
        const texture = (0, $7vBln.default).getTexture($17167019e781eef9$var$MASK_PATH);
        const mask = new $iuB9z.Sprite(texture);
        mask.width = this.infoSliderDims.width;
        mask.height = this.infoSliderDims.height;
        mask.anchor.set(.5);
        this.addChild(mask);
        this.Pages.mask = mask;
    }
    addPages() {
        this.Pages = new $iuB9z.Container();
        this.addChild(this.Pages);
        this.infoSliderAssets.forEach((Asset, assetIndex)=>{
            const slide = new (0, $lnWcW.default)(Asset);
            slide.x = this.infoSliderDims.width * assetIndex;
            slide.y = 0;
            this.Pages.addChild(slide);
        });
    }
    setPageWithArrow(v) {
        const newPage = Math.min(this.infoSliderAssets.length - 1, Math.max(0, this.currPageIndex + v));
        this.setPage(newPage);
    }
    setPage(pNumber) {
        const delta = Math.abs(pNumber - this.currPageIndex);
        this.currPageIndex = pNumber;
        const offsetX = this.infoSliderDims.width * pNumber;
        const duration = 100 * delta;
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).setCurPage, this.currPageIndex);
        new (0, $WbeEW.default)(this.Pages, -offsetX, duration);
    }
}

});
parcelRegister("lnWcW", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1bc4af94e51832f$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $7vBln = parcelRequire("7vBln");

var $fGH3X = parcelRequire("fGH3X");
class $f1bc4af94e51832f$export$2e2bcd8739ae039 extends $iuB9z.Sprite {
    InfoSlider = (0, $fGH3X.default).getInstance();
    constructor(path){
        super();
        this.generate(path);
    }
    generate(path) {
        this.texture = (0, $7vBln.default).getTexture(path);
        this.anchor.set(.5);
        this.scale.set(.42);
        this.x = this.InfoSlider.x;
        this.y = this.InfoSlider.y;
    }
}

});

parcelRegister("WbeEW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a190ab98ec167339$export$2e2bcd8739ae039);

var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $a190ab98ec167339$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    constructor(Container, offsetX, duration){
        super();
        new (0, $6m47o.default).Tween(Container).to({
            x: offsetX
        }, duration * 2).easing((0, $6m47o.default).Easing.Linear.None).start();
    }
}

});


parcelRegister("2Z2Y1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e0627fc423342ca$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $fGH3X = parcelRequire("fGH3X");

var $erVR3 = parcelRequire("erVR3");

var $7vBln = parcelRequire("7vBln");

var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");
const $5e0627fc423342ca$var$ARROW_PATH = "/info-slider/arrow.png";
class $5e0627fc423342ca$export$2e2bcd8739ae039 extends $iuB9z.Container {
    InfoSlider = (0, $fGH3X.default).getInstance();
    infoSliderDims;
    rightArrow;
    leftArrow;
    constructor(infoSliderDims){
        super();
        this.infoSliderDims = infoSliderDims;
        this.addToCon();
        this.addLeftArrow();
        this.addRightArrow();
    }
    handleArrow = (v)=>(0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).setInfoSliderPageWArr, v);
    setArrowInteractivity(arrow, interactive) {
        arrow.interactive = interactive;
        arrow.alpha = interactive ? 1 : .5;
    }
    updateArrowAvaible(eState) {
        if (eState == "first") {
            this.setArrowInteractivity(this.leftArrow, false);
            this.setArrowInteractivity(this.rightArrow, true);
        } else if (eState == "last") {
            this.setArrowInteractivity(this.leftArrow, true);
            this.setArrowInteractivity(this.rightArrow, false);
        } else if (eState == "middle") {
            this.setArrowInteractivity(this.leftArrow, true);
            this.setArrowInteractivity(this.rightArrow, true);
        }
    }
    addLeftArrow() {
        const coord = {
            x: -this.infoSliderDims.width / 2 - 40,
            y: 0
        };
        this.leftArrow = this.generateArrow(coord, false);
    }
    addRightArrow() {
        const coord = {
            x: this.infoSliderDims.width / 2 + 40,
            y: 0
        };
        this.rightArrow = this.generateArrow(coord, true);
    }
    generateArrow(coord, isRight) {
        let texture = (0, $7vBln.default).getTexture($5e0627fc423342ca$var$ARROW_PATH);
        const arrowCon = this.addChild(new $iuB9z.Container());
        arrowCon.scale.set(.17);
        const Arrow = arrowCon.addChild(new $iuB9z.Sprite(texture));
        Object.assign(arrowCon, coord);
        Arrow.width = 241;
        Arrow.height = 403;
        Arrow.anchor.set(.5);
        Arrow.rotation = isRight ? 0 : Math.PI;
        const handleDownFunc = ()=>this.handleArrow(isRight ? 1 : -1);
        (0, $16Wgx.default)(Arrow, {
            handleDownFunc: handleDownFunc
        }, (0, $16HUD.CustomCursorType).pointer, undefined, true);
        return arrowCon;
    }
    addToCon() {
        this.InfoSlider.addChild(this);
    }
}

});

parcelRegister("6cuzD", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab4b3a9edad5f37e$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $fGH3X = parcelRequire("fGH3X");

var $erVR3 = parcelRequire("erVR3");

var $3ANoO = parcelRequire("3ANoO");

var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");
class $ab4b3a9edad5f37e$export$2e2bcd8739ae039 extends $iuB9z.Graphics {
    InfoSlider = (0, $fGH3X.default).getInstance();
    infoSliderDims;
    pNumber;
    currentPage = false;
    constructor(pNumber, x, infoSliderDims){
        super();
        this.pNumber = pNumber;
        this.currentPage = !pNumber;
        this.infoSliderDims = infoSliderDims;
        this.generate();
        this.addCoord(x);
        this.addToCon();
        const handleDownFunc = ()=>this.setInfoSliderPage();
        (0, $16Wgx.default)(this, {
            handleDownFunc: handleDownFunc
        }, (0, $16HUD.CustomCursorType).pointer, undefined, true);
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).setCurPage, (cPage)=>this.setCurPage(Number(cPage)));
    }
    addToCon = ()=>this.InfoSlider.addChild(this);
    setInfoSliderPage = ()=>(0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).setInfoSliderPage, this.pNumber);
    setCurPage(curPage) {
        this.currentPage = curPage == this.pNumber ? true : false;
        this.generate();
    }
    addCoord(x) {
        this.x = x;
        this.y = this.infoSliderDims.height / 2 + 25;
    }
    generate() {
        const dotColor = (0, $3ANoO.CENTER_ANGLE_COLOR);
        const cs = {
            fill: this.currentPage ? dotColor.color : 0xFFFFFF,
            color: !this.currentPage ? dotColor.textColor : dotColor.color
        };
        this.clear().circle(0, 0, 10).fill(cs.fill).stroke({
            width: 2,
            color: cs.color
        });
    }
}

});


parcelRegister("3DpJv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c4b6860014e206b$export$2e2bcd8739ae039);

var $c6c6Q = parcelRequire("c6c6Q");

var $3ANoO = parcelRequire("3ANoO");
const $0c4b6860014e206b$var$getText = (isSingle)=>`Drag the point${isSingle ? "" : "s"} on the circle`;
const $0c4b6860014e206b$var$color = 0xF82400;
class $0c4b6860014e206b$export$2e2bcd8739ae039 extends (0, $c6c6Q.default) {
    constructor(coord = (0, $3ANoO.GUIDE_TEXT_COORD), isJustOnePoint = false){
        super($0c4b6860014e206b$var$getText(isJustOnePoint), $0c4b6860014e206b$var$color, coord);
    }
}

});
parcelRegister("c6c6Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $6993fcb5d799ecf0$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $75RpY = parcelRequire("75RpY");

var $9ec1t = parcelRequire("9ec1t");

var $kSVlj = parcelRequire("kSVlj");
class $6993fcb5d799ecf0$export$2e2bcd8739ae039 extends $iuB9z.Text {
    Game = (0, $75RpY.default).getInstance();
    Layers = (0, $9ec1t.default).getInstance();
    constructor(text, color, coord, yOffset = 0){
        super();
        this.addCoord(coord, yOffset);
        this.addDetails(text, color);
        this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Info.addChild(this);
    setVisible(visible) {
        if (visible) {
            const onUpdate = (v)=>this.scale.set(v);
            this.visible = true;
            this.scale.set(.5);
            new (0, $kSVlj.default)(.5, 1, (v)=>onUpdate(v));
            return;
        }
        this.visible = visible;
    }
    addCoord(coord, yOffset) {
        const dim = this.Game.getDim();
        if (dim.WIDTH > dim.HEIGHT) return Object.assign(this, coord);
        this.x = dim.WIDTH / 2;
        this.y = 460 + yOffset;
        this.anchor.set(.5);
    }
    addDetails(text, color) {
        this.text = text;
        this.style.fill = color;
        this.style.fontWeight = "600";
        this.style.fontStyle = "italic";
        this.style.fontSize = 30;
    }
}

});



//# sourceMappingURL=index.754fe3cf.js.map
